
import { Options, Vue } from 'vue-class-component';
import Sudoku from '../services/Sudoku';

@Options({
  emits: ['click'],
  props: {
    notesMode: Boolean
  }
})
export default class Controls extends Vue {
  difficulties = Sudoku.DIFFICULTY;
  isDropdownOpen = false;
  numpad = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9']
  ];

  toggleDropdown = () => {
    this.isDropdownOpen = !this.isDropdownOpen;
  };

  onClickNew = (value: number) => {
    this.$emit('click', ['new', value]);
    this.isDropdownOpen = false;
  };
}
